import { isFormula, equalFormulas } from "./functions"

export const compareFormulas = (formulaDataBase: string, formulaUser: string, variable = 'x') => {

    const formula = formulaDataBase.replace(/ /g,'').replaceAll(variable, 'X');
    const formulaUsuario = formulaUser.replace(/ /g,'').replaceAll(variable, 'X');

    if (formulaUsuario === '') {
        return { 
            ok: null, 
            title: '¡Cuidado!',
            msg: 'No has ingresado una respuesta'
        }
    }

    if (!isFormula(formulaUsuario).ok) {
        return { 
            ok: null, 
            title: '¡Cuidado!',
            msg: 'Tu respuesta no representa una fórmula'
        }
    }

    if (!equalFormulas(formula,formulaUsuario).ok) {
        return { 
            ok: false, 
            title: 'Sigue intentando!',
            msg: 'Tu respuesta no coincide con la solución'
        }
    }

    return { 
        ok: true, 
        title: '¡Felicitaciones!',
        msg: 'Has encontrado la solución'
    }
}
